import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import ScheduledTransactionService from '../../../service/ScheduledTransactionService';
import Grid from '../../grid/Grid';
import FieldSet from '../../fieldset/FieldSet';
import SearchBar from '../../searchbar/SearchBar';
import DetailedScheduledTransactionModal from './DetailedScheduledTransactionModal';
import { cartingServiceScheduledTransaction, paymentScheduledServiceTransaction, } from '../../../modules/Constants';

class ScheduledTransactionSearchView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      PSSData: null,
      CSSPData: null,
    };
    this.searchBar = React.createRef();
    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'emailAddress',
        display: 'Email Address',
      },
      {
        value: 'transactionId',
        display: 'Scheduled Payment ID',
      },
    ];
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.statefulInitialization(requestedState);
    }
  }

  getTransactions(criteria, onCompletion) {
    const PSSPromise = ScheduledTransactionService.getScheduledTransactionsBySearchCriteria(criteria)
      .then(response => response.data);
    const CSSPPromise = ScheduledTransactionService.getCSSchedulePaymentsBySearchCriteria(criteria)
      .then(response => response.data);

    Promise.all([ PSSPromise, CSSPPromise, ])
      .then(([ PSSResultSet, CSSPResultSet, ]) => {
        const allowedPSSKeys = [
          'creationDate',
          'id',
          'paymentDate',
          'scheduledTransactionStatus',
          'serviceOfferingId',
          'submission_guest-email',
        ];
        const allowedCSKeys = [
          'createdDate',
          'customerId',
          'emailAddress',
          'id',
          'paymentAccountId',
          'paymentDate',
          'status',
          'transactionType',
        ];
        const transactions = PSSResultSet.transactions.map(transaction => lodash.pick(transaction, allowedPSSKeys));
        const csPayments = CSSPResultSet.CSScheduledPayments.map(payment => lodash.pick(payment, allowedCSKeys));

        const PSSHeaders = this.getHeadersFromResultSetData(transactions);
        const PSSRows = this.getRowsFromResultSetData(transactions);
        const CSSPHeaders = this.getHeadersFromResultSetData(csPayments);
        const CSSPRows = this.getRowsFromResultSetData(csPayments);
        const PSSData = {
          headers: PSSHeaders,
          rows: PSSRows,
          selectedTransaction: null,
          type: paymentScheduledServiceTransaction,
        };
        const CSSPData = {
          headers: CSSPHeaders,
          rows: CSSPRows,
          selectedTransaction: null,
          type: cartingServiceScheduledTransaction,
        };

        this.setState({
          PSSData,
          CSSPData,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  }

  getRowsFromResultSetData(transactionArray) {
    const rows = [];
    transactionArray.forEach((transaction) => {
      const row = Object.values(transaction);
      rows.push({
        value: row,
        raw: transaction,
      });
    });
    return rows;
  }

  getHeadersFromResultSetData(transactionArray) {
    let headers = [];
    if (transactionArray.length > 0) {
      headers = Object.keys(transactionArray[0]).map(header => ({
        value: header,
        display: lodash.startCase(header),
      }));
    }
    return (headers);
  }

  onClick(event) {
    this.reset();
    const { search, combo, } = event;
    const { requestedState, } = this.props;
    const criteria = {};

    if (requestedState && !search.value) {
      criteria.customerId = requestedState.id;
    } else {
      criteria[combo.value] = search.value;
    }
    this.getTransactions(criteria, event.kill);
  }

  onRowSelect(selectedRow, type) {
    const { PSSData, CSSPData, } = this.state;
    switch (type) {
      case paymentScheduledServiceTransaction:
        PSSData.selectedTransaction = selectedRow;
        this.setState({
          PSSData,
        });
        break;
      case cartingServiceScheduledTransaction:
        CSSPData.selectedTransaction = selectedRow;
        this.setState({
          CSSPData,
        });
        break;
      default:
        throw new Error(`Invalid Type: ${type}`);
    }
  }

  reset() {
    this.setState({
      PSSData: null,
      CSSPData: null,
    });
  }

  statefulInitialization(customerId) {
    this.setState({
      customerId,
    });

    const { click, } = this;
    if (click) {
      click();
    }
  }

  showSelectedTransactionInfo(selectedTransaction, transactionType) {
    const { sendNavigationRequest, } = this.props;
    if (!selectedTransaction) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${selectedTransaction.id}`}</p>
        <hr />
        <DetailedScheduledTransactionModal
          sendNavigationRequest={sendNavigationRequest}
          scheduledTransaction={selectedTransaction}
          transactionType={transactionType}
        />
      </div>
    );
  }

  getGrid(data, title) {
    if (data == null) {
      return null;
    }
    const {
      rows = [], headers = [], selectedTransaction, type,
    } = data;
    if (headers.length === 0) {
      return null;
    }
    return (
      <div style={{ marginTop: '20px', }}>
        <FieldSet title={title} style={{ maxHeight: '500px', }}>
          <Grid
            headers={headers}
            rows={rows}
            onRowSelect={row => this.onRowSelect(row, type)}
          />
        </FieldSet>
        {this.showSelectedTransactionInfo(selectedTransaction, type)}
      </div>
    );
  }

  _setClickEvent(click) {
    this.click = click;
  }

  render() {
    const { customerId = '', CSSPData, PSSData, } = this.state;
    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          defaultText={customerId}
          onClick={data => this.onClick(data)}
          clickConsumer={click => this._setClickEvent(click)}
        />
        {this.getGrid(PSSData, 'Scheduled Transactions')}
        {this.getGrid(CSSPData, 'Carting Service Scheduled Transactions')}
      </div>
    );
  }
}

ScheduledTransactionSearchView.defaultProps = {
  requestedState: undefined,
};

ScheduledTransactionSearchView.propTypes = {
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
  requestedState: PropTypes.string,
};

export default ScheduledTransactionSearchView;
